export default __webpack_public_path__ + "static/media/chain-11.8c9ff6aa.png";